import React from 'react';
import { BrandIcon, ChevronIcon } from '../../ui/common';

export interface SidebarHeaderProps {
  showSidebarLabels: boolean;
  isCompact: boolean;
  isSidebarExpanded: boolean;
  onNavigateToRadar: () => void;
  onToggleSidebar: () => void;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  showSidebarLabels,
  isCompact,
  isSidebarExpanded,
  onNavigateToRadar,
  onToggleSidebar,
}) => (
  <div
    data-testid="app-sidebar-header"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: showSidebarLabels ? 10 : 8,
      padding: showSidebarLabels ? '34px 4px 22px' : '2px 0 0',
      position: 'relative',
      flexShrink: 0,
    }}
  >
    <div
      onClick={onNavigateToRadar}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer',
        flexShrink: 0,
      }}
      title="Zunelo"
    >
      <BrandIcon source="zunelo" size={showSidebarLabels ? 48 : 32} />
      {showSidebarLabels ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <span
            style={{
              fontSize: 30,
              fontStyle: 'normal',
              fontWeight: 800,
              letterSpacing: '-0.03em',
              color: 'var(--z-text)',
            }}
          >
            Zunelo
          </span>
        </div>
      ) : null}
    </div>

    {isCompact ? null : (
      <button
        type="button"
        onClick={onToggleSidebar}
        aria-expanded={isSidebarExpanded}
        aria-controls="app-sidebar"
        style={{
          position: 'absolute',
          top: 12,
          right: 0,
          width: 26,
          height: 26,
          flex: '0 0 26px',
          borderRadius: 6,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent',
          border: 'none',
          color: 'var(--z-dim)',
          cursor: 'pointer',
          padding: 0,
        }}
        title={isSidebarExpanded ? 'Colapsar barra lateral' : 'Expandir barra lateral'}
      >
        <ChevronIcon size={15} direction={isSidebarExpanded ? 'left' : 'right'} animated />
      </button>
    )}
  </div>
);
